import TYPES from '../../types';

// Domain
import { OnBoardingStepsRepository } from '../../domain/repository/on-boarding-steps-repository';
import { StepNewClientWasAddedDto } from '../../domain/dtos/step-new-client-was-added-dto';
import { StepNewClientWasAddedEntity } from '../../domain/entities/step-new-client-was-added-entity';
import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Query from '@/modules/shared/domain/services/query';

@Injectable()
export default class SearchStepNewClientWasAddedQuery extends
  Query<Promise<Array<StepNewClientWasAddedEntity>>> {
  @Inject(TYPES.ON_BOARDING_STEPS_REPOSITORY)
  private readonly on_boarding_steps_repository!: OnBoardingStepsRepository;

  internalExecute(payload: StepNewClientWasAddedDto): Promise<Array<StepNewClientWasAddedEntity>> {
    return new Promise((resolve, reject) => {
      this.on_boarding_steps_repository.search_step_new_client_was_added(payload)
        .then((data) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
}
